export const VALIDGUESSES = [
    {
        "value": "With You",
        "label": "With You"
    },
    {
        "value": "Life Goes On",
        "label": "Life Goes On"
    },
    {
        "value": "Fly To My Room",
        "label": "Fly To My Room"
    },
    {
        "value": "Blue & Grey",
        "label": "Blue & Grey"
    },
    {
        "value": "Telepathy",
        "label": "Telepathy"
    },
    {
        "value": "Dis-ease",
        "label": "Dis-ease"
    },
    {
        "value": "Stay",
        "label": "Stay"
    },
    {
        "value": "Dynamite",
        "label": "Dynamite"
    },
    {
        "value": "INTRO : Calling",
        "label": "INTRO : Calling"
    },
    {
        "value": "Lights",
        "label": "Lights"
    },
    {
        "value": "Your eyes tell",
        "label": "Your eyes tell"
    },
    {
        "value": "OUTRO : The Journey",
        "label": "OUTRO : The Journey"
    },
    {
        "value": "Intro : Persona",
        "label": "Intro : Persona"
    },
    {
        "value": "Boy With Luv (Feat. Halsey)",
        "label": "Boy With Luv (Feat. Halsey)"
    },
    {
        "value": "Make It Right",
        "label": "Make It Right"
    },
    {
        "value": "Jamais Vu",
        "label": "Jamais Vu"
    },
    {
        "value": "Dionysus",
        "label": "Dionysus"
    },
    {
        "value": "Interlude : Shadow",
        "label": "Interlude : Shadow"
    },
    {
        "value": "Black Swan",
        "label": "Black Swan"
    },
    {
        "value": "Filter",
        "label": "Filter"
    },
    {
        "value": "My Time",
        "label": "My Time"
    },
    {
        "value": "Louder than bombs",
        "label": "Louder than bombs"
    },
    {
        "value": "ON",
        "label": "ON"
    },
    {
        "value": "UGH!",
        "label": "UGH!"
    },
    {
        "value": "00:00 (Zero O’Clock)",
        "label": "00:00 (Zero O’Clock)"
    },
    {
        "value": "Inner Child",
        "label": "Inner Child"
    },
    {
        "value": "Friends",
        "label": "Friends"
    },
    {
        "value": "Moon",
        "label": "Moon"
    },
    {
        "value": "Respect",
        "label": "Respect"
    },
    {
        "value": "We are Bulletproof : the Eternal",
        "label": "We are Bulletproof : the Eternal"
    },
    {
        "value": "Outro : Ego",
        "label": "Outro : Ego"
    },
    {
        "value": "Mikrokosmos",
        "label": "Mikrokosmos"
    },
    {
        "value": "HOME",
        "label": "HOME"
    },
    {
        "value": "Euphoria",
        "label": "Euphoria"
    },
    {
        "value": "Trivia 起 : Just Dance",
        "label": "Trivia 起 : Just Dance"
    },
    {
        "value": "Trivia 承 : Love",
        "label": "Trivia 承 : Love"
    },
    {
        "value": "Trivia 轉 : Seesaw",
        "label": "Trivia 轉 : Seesaw"
    },
    {
        "value": "Epiphany",
        "label": "Epiphany"
    },
    {
        "value": "I'm Fine",
        "label": "I'm Fine"
    },
    {
        "value": "IDOL",
        "label": "IDOL"
    },
    {
        "value": "Answer : Love Myself",
        "label": "Answer : Love Myself"
    },
    {
        "value": "Intro: Singularity",
        "label": "Intro: Singularity"
    },
    {
        "value": "FAKE LOVE",
        "label": "FAKE LOVE"
    },
    {
        "value": "The Truth Untold (feat. Steve Aoki)",
        "label": "The Truth Untold (feat. Steve Aoki)"
    },
    {
        "value": "134340",
        "label": "134340"
    },
    {
        "value": "Paradise",
        "label": "Paradise"
    },
    {
        "value": "Love Maze",
        "label": "Love Maze"
    },
    {
        "value": "Magic Shop",
        "label": "Magic Shop"
    },
    {
        "value": "Airplane pt.2",
        "label": "Airplane pt.2"
    },
    {
        "value": "Anpanman",
        "label": "Anpanman"
    },
    {
        "value": "So What",
        "label": "So What"
    },
    {
        "value": "Outro: Tear",
        "label": "Outro: Tear"
    },
    {
        "value": "Don't Leave Me",
        "label": "Don't Leave Me"
    },
    {
        "value": "Crystal Snow",
        "label": "Crystal Snow"
    },
    {
        "value": "Let Go",
        "label": "Let Go"
    },
    {
        "value": "Intro: Serendipity",
        "label": "Intro: Serendipity"
    },
    {
        "value": "DNA",
        "label": "DNA"
    },
    {
        "value": "Best Of Me",
        "label": "Best Of Me"
    },
    {
        "value": "dimple",
        "label": "dimple"
    },
    {
        "value": "Pied Piper",
        "label": "Pied Piper"
    },
    {
        "value": "MIC Drop",
        "label": "MIC Drop"
    },
    {
        "value": "Go Go",
        "label": "Go Go"
    },
    {
        "value": "Outro: Her",
        "label": "Outro: Her"
    },
    {
        "value": "Spring Day",
        "label": "Spring Day"
    },
    {
        "value": "Not Today",
        "label": "Not Today"
    },
    {
        "value": "Outro: Wings",
        "label": "Outro: Wings"
    },
    {
        "value": "A Supplementary Story: You Never Walk Alone",
        "label": "A Supplementary Story: You Never Walk Alone"
    },
    {
        "value": "Intro: Boy Meets Evil",
        "label": "Intro: Boy Meets Evil"
    },
    {
        "value": "Blood Sweat & Tears",
        "label": "Blood Sweat & Tears"
    },
    {
        "value": "Begin",
        "label": "Begin"
    },
    {
        "value": "Lie",
        "label": "Lie"
    },
    {
        "value": "Stigma",
        "label": "Stigma"
    },
    {
        "value": "First Love",
        "label": "First Love"
    },
    {
        "value": "Reflection",
        "label": "Reflection"
    },
    {
        "value": "MAMA",
        "label": "MAMA"
    },
    {
        "value": "Awake",
        "label": "Awake"
    },
    {
        "value": "Lost",
        "label": "Lost"
    },
    {
        "value": "BTS Cypher 4",
        "label": "BTS Cypher 4"
    },
    {
        "value": "Am I Wrong",
        "label": "Am I Wrong"
    },
    {
        "value": "21st Century Girl",
        "label": "21st Century Girl"
    },
    {
        "value": "2! 3!",
        "label": "2! 3!"
    },
    {
        "value": "Good Day",
        "label": "Good Day"
    },
    {
        "value": "Wishing On A Star",
        "label": "Wishing On A Star"
    },
    {
        "value": "For You",
        "label": "For You"
    },
    {
        "value": "Intro: The Most Beautiful Moment in Life",
        "label": "Intro: The Most Beautiful Moment in Life"
    },
    {
        "value": "I Need U",
        "label": "I Need U"
    },
    {
        "value": "Hold Me Tight",
        "label": "Hold Me Tight"
    },
    {
        "value": "Autumn Leaves",
        "label": "Autumn Leaves"
    },
    {
        "value": "Run",
        "label": "Run"
    },
    {
        "value": "Ma City",
        "label": "Ma City"
    },
    {
        "value": "Silver Spoon",
        "label": "Silver Spoon"
    },
    {
        "value": "Dope",
        "label": "Dope"
    },
    {
        "value": "Burning Up (Fire)",
        "label": "Burning Up (Fire)"
    },
    {
        "value": "Save Me",
        "label": "Save Me"
    },
    {
        "value": "Epilogue: Young Forever",
        "label": "Epilogue: Young Forever"
    },
    {
        "value": "Converse High",
        "label": "Converse High"
    },
    {
        "value": "Moving On",
        "label": "Moving On"
    },
    {
        "value": "Whalien 52",
        "label": "Whalien 52"
    },
    {
        "value": "Butterfly",
        "label": "Butterfly"
    },
    {
        "value": "House of Cards - Full Length Edition",
        "label": "House of Cards - Full Length Edition"
    },
    {
        "value": "Love Is Not Over - Full Length Edition",
        "label": "Love Is Not Over - Full Length Edition"
    },
    {
        "value": "Intro: Never Mind",
        "label": "Intro: Never Mind"
    },
    {
        "value": "Boyz with Fun",
        "label": "Boyz with Fun"
    },
    {
        "value": "Intro.",
        "label": "Intro."
    },
    {
        "value": "The Stars",
        "label": "The Stars"
    },
    {
        "value": "Iine!",
        "label": "Iine!"
    },
    {
        "value": "Iine!Pt.2 - Ano Bashode -",
        "label": "Iine!Pt.2 - Ano Bashode -"
    },
    {
        "value": "Wake Up",
        "label": "Wake Up"
    },
    {
        "value": "Outro.",
        "label": "Outro."
    },
    {
        "value": "Intro: What Am I to You",
        "label": "Intro: What Am I to You"
    },
    {
        "value": "Danger",
        "label": "Danger"
    },
    {
        "value": "War of Hormone",
        "label": "War of Hormone"
    },
    {
        "value": "Hip Hop Phile",
        "label": "Hip Hop Phile"
    },
    {
        "value": "Let Me Know",
        "label": "Let Me Know"
    },
    {
        "value": "Rain",
        "label": "Rain"
    },
    {
        "value": "BTS Cypher Pt.3: Killer",
        "label": "BTS Cypher Pt.3: Killer"
    },
    {
        "value": "Could You Turn off Your Cell Phone",
        "label": "Could You Turn off Your Cell Phone"
    },
    {
        "value": "Embarrassed",
        "label": "Embarrassed"
    },
    {
        "value": "24/7=Heaven",
        "label": "24/7=Heaven"
    },
    {
        "value": "Look Here",
        "label": "Look Here"
    },
    {
        "value": "2nd Grade",
        "label": "2nd Grade"
    },
    {
        "value": "Outro: Do You Think It Makes Sense?",
        "label": "Outro: Do You Think It Makes Sense?"
    },
    {
        "value": "Miss Right",
        "label": "Miss Right"
    },
    {
        "value": "Intro: Skool Luv Affair",
        "label": "Intro: Skool Luv Affair"
    },
    {
        "value": "Boy in Luv",
        "label": "Boy in Luv"
    },
    {
        "value": "Where You From",
        "label": "Where You From"
    },
    {
        "value": "Just One Day",
        "label": "Just One Day"
    },
    {
        "value": "Tomorrow",
        "label": "Tomorrow"
    },
    {
        "value": "BTS Cypher Pt.2: Triptych",
        "label": "BTS Cypher Pt.2: Triptych"
    },
    {
        "value": "Spine Breaker",
        "label": "Spine Breaker"
    },
    {
        "value": "Jump",
        "label": "Jump"
    },
    {
        "value": "Outro: Propose",
        "label": "Outro: Propose"
    },
    {
        "value": "Intro: Skool Luv Affair",
        "label": "Intro: Skool Luv Affair"
    },
    {
        "value": "Boy in Luv",
        "label": "Boy in Luv"
    },
    {
        "value": "Where You From",
        "label": "Where You From"
    },
    {
        "value": "Just One Day",
        "label": "Just One Day"
    },
    {
        "value": "Tomorrow",
        "label": "Tomorrow"
    },
    {
        "value": "BTS Cypher Pt.2: Triptych",
        "label": "BTS Cypher Pt.2: Triptych"
    },
    {
        "value": "Spine Breaker",
        "label": "Spine Breaker"
    },
    {
        "value": "Jump",
        "label": "Jump"
    },
    {
        "value": "Outro: Propose",
        "label": "Outro: Propose"
    },
    {
        "value": "Intro: O!RUL8,2?",
        "label": "Intro: O!RUL8,2?"
    },
    {
        "value": "N.O",
        "label": "N.O"
    },
    {
        "value": "We On",
        "label": "We On"
    },
    {
        "value": "If I Ruled the World",
        "label": "If I Ruled the World"
    },
    {
        "value": "Coffee",
        "label": "Coffee"
    },
    {
        "value": "BTS Cypher Pt.1",
        "label": "BTS Cypher Pt.1"
    },
    {
        "value": "Attack on Bangtan",
        "label": "Attack on Bangtan"
    },
    {
        "value": "Paldogangsan",
        "label": "Paldogangsan"
    },
    {
        "value": "Outro: Luv in Skool",
        "label": "Outro: Luv in Skool"
    },
    {
        "value": "Intro: 2 Cool 4 Skool",
        "label": "Intro: 2 Cool 4 Skool"
    },
    {
        "value": "We Are Bulletproof Pt.2",
        "label": "We Are Bulletproof Pt.2"
    },
    {
        "value": "No More Dream",
        "label": "No More Dream"
    },
    {
        "value": "Like",
        "label": "Like"
    },
    {
        "value": "Outro: Circle Room Cypher",
        "label": "Outro: Circle Room Cypher"
    },
    {
        "value": "My Universe",
        "label": "My Universe"
    },
    {
        "value": "Permission to Dance",
        "label": "Permission to Dance"
    },
    {
        "value": "Butter",
        "label": "Butter"
    },
    {
        "value": "Film out",
        "label": "Film out"
    },
    {
        "value": "Savage Love (Laxed – Siren Beat) [BTS Remix]",
        "label": "Savage Love (Laxed – Siren Beat) [BTS Remix]"
    },
    {
        "value": "Dynamite",
        "label": "Dynamite"
    },
    {
        "value": "Stay Gold",
        "label": "Stay Gold"
    },
    {
        "value": "Black Swan",
        "label": "Black Swan"
    },
    {
        "value": "SUGA's Interlude",
        "label": "SUGA's Interlude"
    },
    {
        "value": "Make It Right (feat. Lauv)",
        "label": "Make It Right (feat. Lauv)"
    },
    {
        "value": "Old Town Road (feat. RM of BTS) - Seoul Town Road Remix",
        "label": "Old Town Road (feat. RM of BTS) - Seoul Town Road Remix"
    },
    {
        "value": "Waste It On Me",
        "label": "Waste It On Me"
    },
    {
        "value": "FAKE LOVE - Rocking Vibe Mix",
        "label": "FAKE LOVE - Rocking Vibe Mix"
    },
    {
        "value": "Come Back Home",
        "label": "Come Back Home"
    },
    {
        "value": "Good Day",
        "label": "Good Day"
    },
    {
        "value": "For You",
        "label": "For You"
    },
    {
        "value": "Heartbeat (BTS World Original Soundtrack)",
        "label": "Heartbeat (BTS World Original Soundtrack)"
    },
    {
        "value": "Dream Glow (BTS World Original Soundtrack) [Pt. 1]",
        "label": "Dream Glow (BTS World Original Soundtrack) [Pt. 1]"
    },
    {
        "value": "A Brand New Day (BTS World Original Soundtrack) [Pt. 2]",
        "label": "A Brand New Day (BTS World Original Soundtrack) [Pt. 2]"
    },
    {
        "value": "All Night (BTS World Original Soundtrack) [Pt. 3]",
        "label": "All Night (BTS World Original Soundtrack) [Pt. 3]"
    },
    {
        "value": "Who (feat. BTS)",
        "label": "Who (feat. BTS)"
    },
    {
        "value": "Change",
        "label": "Change"
    },
    {
        "value": "tokyo",
        "label": "tokyo"
    },
    {
        "value": "seoul (prod. HONNE)",
        "label": "seoul (prod. HONNE)"
    },
    {
        "value": "moonchild",
        "label": "moonchild"
    },
    {
        "value": "badbye",
        "label": "badbye"
    },
    {
        "value": "uhgood",
        "label": "uhgood"
    },
    {
        "value": "everythingoes",
        "label": "everythingoes"
    },
    {
        "value": "forever rain",
        "label": "forever rain"
    },
    {
        "value": "Champion - Remix",
        "label": "Champion - Remix"
    },
    {
        "value": "WINTER FLOWER(Feat.RM)",
        "label": "WINTER FLOWER(Feat.RM)"
    },
    {
        "value": "U (Feat. Kwon Jin Ah & Rap Monster)",
        "label": "U (Feat. Kwon Jin Ah & Rap Monster)"
    },
    {
        "value": "Don't (feat. RM)",
        "label": "Don't (feat. RM)"
    },
    {
        "value": "Crying Over You ◐ (feat. RM & BEKA)",
        "label": "Crying Over You ◐ (feat. RM & BEKA)"
    },
    {
        "value": "ProMeTheUs",
        "label": "ProMeTheUs"
    },
    {
        "value": "Gajah (Feat. RM)",
        "label": "Gajah (Feat. RM)"
    },
    {
        "value": "Timeless",
        "label": "Timeless"
    },
    {
        "value": "Hope World",
        "label": "Hope World"
    },
    {
        "value": "P.O.P (Piece Of Peace) Pt. 1",
        "label": "P.O.P (Piece Of Peace) Pt. 1"
    },
    {
        "value": "Daydream (백일몽)",
        "label": "Daydream (백일몽)"
    },
    {
        "value": "Base Line",
        "label": "Base Line"
    },
    {
        "value": "항상 (HANGSANG)",
        "label": "항상 (HANGSANG)"
    },
    {
        "value": "Airplane",
        "label": "Airplane"
    },
    {
        "value": "Blue Side (Outro)",
        "label": "Blue Side (Outro)"
    },
    {
        "value": "Chicken Noodle Soup (feat. Becky G)",
        "label": "Chicken Noodle Soup (feat. Becky G)"
    },
    {
        "value": "It's Definitely You",
        "label": "It's Definitely You"
    },
    {
        "value": "Sweet Night",
        "label": "Sweet Night"
    },
    {
        "value": "Christmas Tree",
        "label": "Christmas Tree"
    },
    {
        "value": "Yours",
        "label": "Yours"
    },
    {
        "value": "Moonlight",
        "label": "Moonlight"
    },
    {
        "value": "Daechwita",
        "label": "Daechwita"
    },
    {
        "value": "What do you think?",
        "label": "What do you think?"
    },
    {
        "value": "Strange (feat. RM)",
        "label": "Strange (feat. RM)"
    },
    {
        "value": "28 (feat. NiiHWA)",
        "label": "28 (feat. NiiHWA)"
    },
    {
        "value": "Burn It (feat. MAX)",
        "label": "Burn It (feat. MAX)"
    },
    {
        "value": "People",
        "label": "People"
    },
    {
        "value": "Honsool",
        "label": "Honsool"
    },
    {
        "value": "Interlude : Set me free",
        "label": "Interlude : Set me free"
    },
    {
        "value": "Dear my friend (feat. Kim Jong Wan of NELL)",
        "label": "Dear my friend (feat. Kim Jong Wan of NELL)"
    },
    {
        "value": "Give It to Me",
        "label": "Give It to Me"
    },
    {
        "value": "724148",
        "label": "724148"
    },
    {
        "value": "140503 at Dawn",
        "label": "140503 at Dawn"
    },
    {
        "value": "The Last",
        "label": "The Last"
    },
    {
        "value": "Tony Montana",
        "label": "Tony Montana"
    },
    {
        "value": "Interlude_dream, Reality",
        "label": "Interlude_dream, Reality"
    },
    {
        "value": "So Far Away",
        "label": "So Far Away"
    },
    {
        "value": "Blueberry Eyes (feat. SUGA of BTS)",
        "label": "Blueberry Eyes (feat. SUGA of BTS)"
    },
    {
        "value": "Song Request 신청곡 (feat. SUGA of BTS)",
        "label": "Song Request 신청곡 (feat. SUGA of BTS)"
    },
    {
        "value": "eight(Prod.&Feat. SUGA of BTS)",
        "label": "eight(Prod.&Feat. SUGA of BTS)"
    },
    {
        "value": "Stay Alive (Prod. SUGA of BTS)",
        "label": "Stay Alive (Prod. SUGA of BTS)"
    },
    {
        "value": "Super Tuna",
        "label": "Super Tuna"
    },
    {
        "value": "Bicycle",
        "label": "Bicycle"
    },
    {
        "value": "Snow Flower",
        "label": "Snow Flower"
    },
    {
        "value": "Christmas Love",
        "label": "Christmas Love"
    },
    {
        "value": "Abyss",
        "label": "Abyss"
    },
    {
        "value": "Still With You",
        "label": "Still With You"
    },
    {
        "value": "Winter Bear",
        "label": "Winter Bear"
    },
    {
        "value": "Tonight",
        "label": "Tonight"
    },
    {
        "value": "Scenery",
        "label": "Scenery"
    },
    {
        "value": "Promise",
        "label": "Promise"
    },
    {
        "value": "DDaeng",
        "label": "DDaeng"
    },
    {
        "value": "4 O'Clock",
        "label": "4 O'Clock"
    },
    {
        "value": "always",
        "label": "always"
    },
    {
        "value": "I Know (RM & JK)",
        "label": "I Know (RM & JK)"
    },
    {
        "value": "Do You",
        "label": "Do You"
    },
    {
        "value": "Awakening",
        "label": "Awakening"
    },
    {
        "value": "Throw Away",
        "label": "Throw Away"
    },
    {
        "value": "Monster",
        "label": "Monster"
    },
    {
        "value": "Joke",
        "label": "Joke"
    },
    {
        "value": "Rush (feat. Krizz Kaliko)",
        "label": "Rush (feat. Krizz Kaliko)"
    },
    {
        "value": "Life",
        "label": "Life"
    },
    {
        "value": "Adrift",
        "label": "Adrift"
    },
    {
        "value": "I Believe",
        "label": "I Believe"
    },
    {
        "value": "So 4 More",
        "label": "So 4 More"
    },
    {
        "value": "Born Singer",
        "label": "Born Singer"
    }
]
